import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';

import Facebook from '../../../../../assets/images/icons/social/facebook.png';
import Instagram from '../../../../../assets/images/icons/social/instagram.png';
import Link from '../../../../components/Link';
import Linkedin from '../../../../../assets/images/icons/social/linkedin.png';
import List from '../../../../components/List';
import Typography from '../../../../foundations/Typography';
import Youtube from '../../../../../assets/images/icons/social/youtube.png';

export const HeadingStyled = styled(Typography)`
  && {
    ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      display: none;

      ${mediumUp
        && `
        display: block;
        margin-bottom: ${rem(8)};
      `}
    `;
  }}
}`;

export const ListStyled = styled(List)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      display: flex;
      margin-top: ${rem(24)};
      text-align: center;

      ${!mediumUp
        && `
          justify-content: center;
        `}

      ${mediumUp
        && `
          margin-top: 0;
          text-align: left;
        `}
    `;
  }
}`;

const getIconLinkStyles = (theme) => css`
  display: block;
  width: ${rem(30)};
  height: ${rem(30)};
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  text-indent: -9999px;

  &:hover {
    outline-color: ${theme.colors.action.lightTheme.linkDefault};
  }

  &:focus {
    /** browser to handle native focus */
    /** offset focus ring for higher visibility */
    outline: auto ${rem(5)} -webkit-focus-ring-color;
  }

  &:active {
    outline-color: ${theme.colors.action.lightTheme.linkHover};
  }
`;

export const ListItemStyled = styled.li`
  margin-right: ${rem(16)};
`;

export const LinkStyledFacebook = styled(Link)`
  ${({ theme }) => css`
    ${getIconLinkStyles(theme)}
    background-image: url(${Facebook});
  `}
`;

export const LinkStyledInstagram = styled(Link)`
  ${({ theme }) => css`
    ${getIconLinkStyles(theme)}
    background-image: url(${Instagram});
  `}
`;

export const LinkStyledLinkedin = styled(Link)`
  ${({ theme }) => css`
    ${getIconLinkStyles(theme)}
    background-image: url(${Linkedin});
  `}
`;

export const LinkStyledYouTube = styled(Link)`
  ${({ theme }) => css`
    ${getIconLinkStyles(theme)}
    background-image: url(${Youtube});
  `}
`;
